import axios from '@/libs/api.request'

// 登录
export const apiLogin = data => {
  return axios.request({
    url: '/sys/login',
    method: 'post',
    data
  })
}

// 退出
export const apiLogout = data => {
  return axios.request({
    url: '/sys/logout',
    method: 'post',
    data
  })
}
